const accountSubdomainKey = "wakelet-account-subdomain";
export const AccountSubdomainStore = {
    set: (hash: string) => {
        localStorage.setItem(accountSubdomainKey, hash);
    },
    get: (): string | null => {
        return localStorage.getItem(accountSubdomainKey)
    },
    clear: () => {
        localStorage.removeItem(accountSubdomainKey);
    }
}

export const toAccountReturnLocation = (redirectUri: string) => {
    const subdomain = (AccountSubdomainStore.get() || "").toLowerCase();
    const parsedURL = new URL(redirectUri);
    const firstSubdomain = getFirstSubdomainFromHostname(parsedURL.host).toLowerCase();

    if (subdomain && firstSubdomain !== "localhost") {
        if (districtWithSubdomains.includes(subdomain) && subdomain !== firstSubdomain) {
            let newURL = `${parsedURL.protocol}//${subdomain}.${parsedURL.host}`
            if (parsedURL.port) {
                newURL += ":"+ parsedURL.port
            }
            return newURL + "/login";
        }
        return redirectUri;
    }

    const isDistrictSubdomain = districtWithSubdomains.includes(firstSubdomain);
    if (isDistrictSubdomain) {
        const hostWithoutDistrictSubdomain = parsedURL.host.replace(`${firstSubdomain}.`, "");
        let newURL = `${parsedURL.protocol}//${hostWithoutDistrictSubdomain}`
        if (parsedURL.port) {
            newURL += ":"+ parsedURL.port
        }
        return newURL + "/login";
    }

    return redirectUri;
}

function getFirstSubdomainFromHostname(hostname: string): string {
    const fragments =  hostname.split(".");
    return fragments.length ? fragments[0] : "";
}

const districtWithSubdomains = [
    "clever-sandbox",
];
